import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { setLoading, saveData } from './actions';
import VMDetails from './component';
import getVMSlotsArray from '../../utils/convertToSlots';

class VMDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vmDetails: null
    };
  }

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);

    const { vmId } = this.props.match.params;
    // alert(orderId);
    if (!vmId) {
      toastr.error('ERROR', 'Invalid VM Id');
      return this.props.history.push('/vendingmachines');
    }

    this.props.getDataFromAPI(
      `/vendingmachines/items?vmId=${vmId}`,
      'GET',
      undefined,
      (response) => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error('ERROR', err.data.message);
        // console.log(err);
      },
      true
    );
  }

  render() {
    // console.log('---------------------> vmDetails props', this.props.vmDetails);
    const details = this.props.vmDetails && this.props.vmDetails.list;
    const vmDetails = this.props.vmDetails && this.props.vmDetails.vmDetails;
    const loading = this.props.vmDetails && this.props.vmDetails.loading;
    const { vmId } = this.props.match.params;

    return (
      <VMDetails
        vmId={vmId}
        loading={loading}
        details={getVMSlotsArray(details)}
        vmDetails={vmDetails}
      />
    );
  }
}

function mapStateToProps({ vmDetails }) {
  return {
    vmDetails
  };
}

export default withRouter(connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
  saveData
})(VMDetailsContainer));



// WEBPACK FOOTER //
// ./src/Modules/VMDetails/container.jsx